import React, { useState } from "react";
import { Card, Col, Row, Form, Input, Button } from "antd";
import { Title } from "@frontend/components/atoms/Title";
import { createPlaywrightForm } from "../../../selection_processes/createPlaywrightForm";
import "./GeneralConfig.scss";

// Refactor de portales: Eliminar este archivo  

const GeneralConfigForm = ({ landingConfig, handleUpdateLanding, form }) => {
  const {
    color,
    site_url,
    linkedin_url,
    twitter_url,
    facebook_url,
    youtube_url,
    instagram_url,
  } = landingConfig;

  const initValues = {
    color: color,
    site_url: site_url,
    linkedin_url: linkedin_url,
    twitter_url: twitter_url,
    facebook_url: facebook_url,
    youtube_url: youtube_url,
    instagram_url: instagram_url,
  };

  const { getFieldDecorator} = form

  const [squareColor, setSquareColor] = useState(!!color ? color : "#f344dd");

  const handleChangeColor = (e) => {
    setSquareColor(e.target.value);
  };

  return (
    <Card
      title={
        <Title className="general-config-mainTitle" level={4}>
          Ajustes de portales
        </Title>
      }
      className="general-config"
    >
      <Form layout="vertical" onSubmit={(e)=> handleUpdateLanding(e, form)}>
        <Row>
          <Col sm={{ span: 11 }} xs={{ span: 24 }}>
            <Form.Item label="Color" name="color">
              {getFieldDecorator("color", {initialValue: color})(
                <Input
                  suffix={
                    <div
                      style={{
                        backgroundColor: squareColor,
                        height: "16px",
                        width: "16px",
                      }}
                    ></div>
                  }
                  onChange={handleChangeColor}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col sm={{ span: 11 }} xs={{ span: 24 }}>
            
            <Form.Item label="Sitio web" name="site_url">
              {getFieldDecorator("site_url", {initialValue: site_url})(
                <Input placeholder="https://" />
              )}
            </Form.Item>
          </Col>
          <Col sm={{ span: 11, offset: 2 }} xs={{ span: 24 }}>
            <Form.Item label="Linkedin" name="linkedin_url">
              {getFieldDecorator("linkedin_url", {initialValue: linkedin_url})(
                <Input type="url" placeholder="https://" pattern="https://.*"/>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col sm={{ span: 11 }} xs={{ span: 24 }}>
            <Form.Item label="Twitter" name="twitter_url">
              {getFieldDecorator("twitter_url", {initialValue: twitter_url})(
                <Input placeholder="https://" />
              )}
            </Form.Item>
          </Col>
          <Col sm={{ span: 11, offset: 2 }} xs={{ span: 24 }}>
            <Form.Item label="Facebook" name="facebook_url">
              {getFieldDecorator("facebook_url", {initialValue: facebook_url})(
                <Input placeholder="https://" />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col sm={{ span: 11 }} xs={{ span: 24 }}>
            <Form.Item label="Youtube" name="youtube_url">
              {getFieldDecorator("youtube_url", {initialValue: youtube_url})(
                <Input placeholder="https://" />
              )}
            </Form.Item>
          </Col>
          <Col sm={{ span: 11, offset: 2 }} xs={{ span: 24 }}>
            <Form.Item label="Instagram" name="instagram_url">
              {getFieldDecorator("instagram_url", {initialValue: instagram_url})(
                <Input placeholder="https://" />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col sm={{ span: 24 }} xs={{ span: 24 }}>
            <Button
              style={{ float: "right" }}
              htmlType="submit"
              type="primary"
              size="large"
            >
              Guardar
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

const createForm = typeof Form.create === "function" ? Form.create : createPlaywrightForm;
const GeneralConfig = createForm({name: "general_config"})(GeneralConfigForm)

export default GeneralConfig;
